import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ScrollSnapScreen.css";
import CardOneScreen from "./CardOneScreen";
import CardTwoScreen from "./CardTwoScreen";
import CardThreeScreen from "./CardThreeScreen";
import CardFourScreen from "./CardFourScreen";
import CardFiveScreen from "./CardFiveScreen";
import CardSixScreen from "./CardSixScreen";
import CardSevenScreen from "./CardSevenScreen";
import CardEightScreen from "./CardEightScreen";

const cards = [
  { type: "card1" },
  { type: "card2" },
  { type: "card3" },
  { type: "card4" },
  { type: "card5" },
  { type: "card6" },
  { type: "card7" },
  { type: "card8" },
];

export default function ScrollSnapScreen() {
  const navigate = useNavigate();
  const [visibleIndex, setVisibleIndex] = useState(0);
  const sectionsRef = useRef<(HTMLElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = sectionsRef.current.findIndex((el) => el === entry.target);
            setVisibleIndex(index);
          }
        });
      },
      {
        threshold: 0.75,
        rootMargin: '0px'
      }
    );

    sectionsRef.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  const setSectionRef = (el: HTMLElement | null, i: number) => {
    sectionsRef.current[i] = el;
  };

  // Scroll to card index
  const scrollToCard = (index: number) => {
    const target = sectionsRef.current[index];
    if (target) {
      target.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });
    }
  };

  return (
    <div className="story-container">
      {cards.map((card, i) => (
        <section
          key={i}
          ref={(el) => setSectionRef(el, i)}
          className={`story-section ${visibleIndex === i ? "active" : ""}`}
        >
          {card.type === "card1" ? (
            <CardOneScreen
              onNew={() => scrollToCard(1)}
              onResources={() => navigate("/resources")}
            />
          ) : card.type === "card2" ? (
            <CardTwoScreen />
          ) : card.type === "card3" ? (
            <CardThreeScreen />
          ) : card.type === "card4" ? (
            <CardFourScreen />
          ) : card.type === "card5" ? (
            <CardFiveScreen />
          ) : card.type === "card6" ? (
            <CardSixScreen />
          ) : card.type === "card7" ? (
            <CardSevenScreen />
          ) : card.type === "card8" ? (
            <CardEightScreen
              onCall={() => window.location.href = '/coaching'}
              onResources={() => navigate("/resources")}
            />
          ) : null}
        </section>
      ))}
    </div>
  );
}
